import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { appConstant, apiUrl } from '@constants';
import { message } from 'antd';
import { ForgotPasswordPresentational } from './forgot-password-presentational';

export const ForgotPasswordFunctional = ({ history, props }) => {
	const [state, setState] = useState({
		authKey: null,
		iscardActive: false,
	});

	const componentDidMount = () => {
		setState({
			...state,
			iscardActive: false,
		});
	};

	const goToLogin = () => {
		props.history.push('/login');
	};

	const onFinish = (values) => {
		const request = values.email;
		Axios.get(`${appConstant.domain + apiUrl.HEALTH}`)
			.then((res) => {
				Axios.get(`${appConstant.domain}${apiUrl.FORGOT_PASSWORD}${request}`)
					.then((res) => {
						if (res.data.success) {
							setState({ ...state, iscardActive: true });
						} else {
							message.error(res.data.messages && res.data.messages[0]);
						}
					})
					.catch((err) => {
						if (err.response) {
							message.error(err.response.data.messages && err.response.data.messages[0]);
						}
					});
			})
			.catch((err) => {});
	};

	useEffect(() => {
		componentDidMount();
	}, []);

	return <ForgotPasswordPresentational props={props} state={state} goToLogin={goToLogin} onFinish={onFinish} />;
};
